import type { HideUnsubmittedAfter, HideUnsubmittedFormRule } from "../../../../../../shared/schema";
import { DEFAULT_HIDE_UNSUBMITTED_AFTER } from "./constants";

export interface HideUnsubmittedSettings {
  hideUnsubmittedAfter?: HideUnsubmittedAfter;
  hideUnsubmittedFormRules?: HideUnsubmittedFormRule[];
}

export const useHideUnsubmittedSection = (
  rules: HideUnsubmittedFormRule[],
  onChange: (updates: HideUnsubmittedSettings) => void
) => {
  const setRules = (next: HideUnsubmittedFormRule[]) =>
    onChange({ hideUnsubmittedFormRules: next.length > 0 ? next : undefined });

  return {
    handleDefaultEnabledChange: (checked: boolean | "indeterminate") =>
      onChange({ hideUnsubmittedAfter: checked === true ? DEFAULT_HIDE_UNSUBMITTED_AFTER : undefined }),
    handleDefaultChange: (hideUnsubmittedAfter: HideUnsubmittedAfter) => onChange({ hideUnsubmittedAfter }),
    addRule: () =>
      setRules([...rules, { id: crypto.randomUUID(), formIds: [], hideAfter: DEFAULT_HIDE_UNSUBMITTED_AFTER }]),
    updateRule: (updated: HideUnsubmittedFormRule) =>
      setRules(rules.map((rule) => (rule.id === updated.id ? updated : rule))),
    removeRule: (id: string) => setRules(rules.filter((rule) => rule.id !== id)),
    formIdsInOtherRules: (id: string) => rules.flatMap((rule) => (rule.id === id ? [] : rule.formIds)),
  };
};
